import { Card, CardContent, Typography } from '@mui/material'
import { Link } from 'react-router-dom'

export const ContactCareTeam = () => {
    return (
        <Card
            elevation={0}
            sx={{
                mt: 2,
                mb: 6,
                border: 1,
                borderColor: 'divider'
            }}
        >
            <CardContent sx={{ px: 4 }}>
                <Typography variant="body2" color="text.secondary">
                    Have questions or concerns? Message your{' '}
                    <Link
                        to="/chat/new"
                        style={{
                            textDecoration: 'underline',
                            color: 'inherit'
                        }}
                    >
                        Care Team
                    </Link>
                    .
                </Typography>
            </CardContent>
        </Card>
    )
}
